/**
 * Linhas da tabela "Compare os planos". Os cards (preço, descrição e destaques)
 * vêm da API; só a tabela fica aqui, porque o banco não tem a comparação.
 *
 * Fonte: docs/features/subscription/matriz-de-planos.md. Nada aqui cria recurso
 * ou limite: ao mudar um plano, atualizar também esta tabela. Plano que não está
 * aqui (novo no banco) fica fora da tabela.
 */

export const PLAN_KEYS = {
  ESSENCIAL: 'essencial',
  PROFISSIONAL: 'profissional',
  BUSINESS: 'business',
};

/** Chave do plano pela primeira palavra do nome (minúsculo): "Business Plus" usa a coluna do Business. */
export const getPlanKey = (plan) => {
  const name = String(plan?.name || '')
    .toLowerCase()
    .trim()
    .split(/\s+/)[0];
  return Object.values(PLAN_KEYS).includes(name) ? name : null;
};

const YES = true;
const NO = false;

/**
 * Linhas da tabela. values: [Essencial, Profissional, Business];
 * true = incluso, false = não incluso, texto = limite.
 */
export const COMPARISON_GROUPS = [
  {
    title: 'Agenda e atendimento',
    rows: [
      { label: 'Agenda, prontuário, anamneses e evolução', values: [YES, YES, YES] },
      { label: 'Tipos de atendimento com medidas, fotos, mapa corporal e plano alimentar, com PDF', values: [YES, YES, YES] },
      { label: 'Atestados e encaminhamentos em PDF', values: [YES, YES, YES] },
      { label: 'Agenda pública por link', values: [YES, YES, YES] },
      { label: 'Lista de espera com oferta de horário vago', values: [NO, YES, YES] },
      { label: 'Pacotes de serviços', values: [NO, YES, YES] },
      { label: 'Relatório completo do atendimento em PDF', values: [NO, YES, YES] },
      { label: 'Link para a pessoa preencher o próprio cadastro', values: [NO, YES, YES] },
    ],
  },
  {
    title: 'Equipe e estrutura',
    rows: [
      { label: 'Profissionais na agenda', values: ['1', 'Até 2', 'Sob medida'] },
      { label: 'Usuários', values: ['1', 'Até 3', 'Sob medida'] },
      { label: 'Salas', values: ['1', 'Até 2', 'Sem limite'] },
      { label: 'Procedimentos ou serviços', values: ['Até 3', 'Sem limite', 'Sem limite'] },
    ],
  },
  {
    title: 'WhatsApp e avisos',
    rows: [
      { label: 'Mensagem pronta no WhatsApp Web, em um clique', values: [YES, YES, YES] },
      { label: 'Confirmações com resposta por botão, enviadas sozinhas pelo seu número', values: [NO, YES, YES] },
      { label: 'Avisos de agendamento e reagendamento na hora, pelo seu número', values: [NO, YES, YES] },
      { label: 'Resumo diário da agenda por e-mail', values: [NO, YES, YES] },
      { label: 'Integração com a Z-API para usar seu próprio número de WhatsApp', third: true, values: [NO, YES, YES] },
      { label: 'Lembrete de 7 dias, boas-vindas, pesquisa de satisfação, avaliação no Google e aniversário, pelo seu número', values: [NO, YES, YES] },
    ],
  },
  {
    title: 'Financeiro e notas',
    rows: [
      { label: 'Financeiro, dashboard e estatísticas', values: [YES, YES, YES] },
      { label: 'Integração com sistema de emissão de nota fiscal (Focus NFe)', third: true, values: [NO, YES, YES] },
      { label: 'Exportação completa dos dados', values: [NO, YES, YES] },
    ],
  },
  {
    title: 'Marketing',
    rows: [
      { label: 'Funil de leads', values: [NO, YES, YES] },
      { label: 'Campanhas, origens de leads e mensagem em massa', values: [NO, NO, YES] },
    ],
  },
  {
    title: 'Suporte',
    rows: [
      { label: 'Suporte por e-mail', values: [YES, YES, YES] },
      { label: 'Suporte prioritário por WhatsApp', values: [NO, NO, YES] },
    ],
  },
];

/** Posição da coluna de cada plano em COMPARISON_GROUPS[].rows[].values */
export const COMPARISON_COLUMN = {
  [PLAN_KEYS.ESSENCIAL]: 0,
  [PLAN_KEYS.PROFISSIONAL]: 1,
  [PLAN_KEYS.BUSINESS]: 2,
};

export const THIRD_PARTY_NOTE = '* Integrações com serviços de terceiros (Z-API e Focus NFe), contratados e pagos à parte.';
